/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-25 10:24:13
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-01-25 10:28:53
 * @FilePath: \crm-product\found\views\sfa\views\order_manage\international_division\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Table from './table';

export default Table;
